// extracted by mini-css-extract-plugin
export var deleteIcon = "_qz-5";
export var deleteOption = "_qz-3";
export var divider = "_qz-2";
export var downloadIcon = "_qz-4";
export var drawer = "_qz-0";
export var drawerFooter = "_qz-6";
export var drawerOpen = "_qz-1";
export var highlighted = "_qz-7";
export var lighterHighlight = "_qz-8";